import { GhostButton } from '@ardoq/button';
import { DescriptionIcon, ViewpointIcon } from '@ardoq/icons';
import { WIDGET_OPTIONS_BUTTON_ID } from '../../consts';
import { WidgetPopover, WidgetPopoverProps } from './WidgetPopover';
import { WithPopover } from '@ardoq/popovers';

export type DrilldownButtonProps = {
  onClick: VoidFunction | undefined;
  popoverProps: WidgetPopoverProps;
  isDisabled: boolean;
  isViewpointSource?: boolean;
};

const DrilldownButton = ({
  onClick,
  isDisabled,
  popoverProps,
  isViewpointSource,
}: DrilldownButtonProps) => (
  <WithPopover key="Widget Popover" content={() => WidgetPopover(popoverProps)}>
    <div // Needs this because tooltips don't trigger on disabled buttons
      id={WIDGET_OPTIONS_BUTTON_ID}
    >
      <GhostButton
        className="show-only-on-hover"
        aria-label={popoverProps.tooltipText || undefined}
        data-click-id={WIDGET_OPTIONS_BUTTON_ID}
        dataTestId={WIDGET_OPTIONS_BUTTON_ID}
        onClick={onClick}
        isDisabled={isDisabled}
      >
        {isViewpointSource ? <ViewpointIcon /> : <DescriptionIcon />}
      </GhostButton>
    </div>
  </WithPopover>
);

export { DrilldownButton };
